<template>
  <div class="days-before-deadline-report">
    <div class="level first-level">
      <h3 class="level-left">
        Data delivery by customer (Number of days before deadline)
      </h3>
      <div class="level-right">
        <div class="apexcharts-legend-series">
          <span
            class="apexcharts-legend-marker data-delivery-deadline-text"
          ></span>
          <span class="apexcharts-legend-text">Data Delivery Deadline</span>
        </div>
        <div class="apexcharts-legend-series">
          <span class="apexcharts-legend-marker scheme-deadline-text"></span>
          <span class="apexcharts-legend-text ">Scheme Deadline</span>
        </div>
      </div>
    </div>
    <div class="level is-12">
      <div class="analytics-datepicker level-left is-6">
        <label>From </label>
        <b-datepicker
          class="analytics-date-picker actual-submission-start-date"
          v-model="from_date"
          required
          icon="calendar-today"
          trap-focus
          v-on:input="getByDate"
        >
        </b-datepicker>

        <label>To </label>
        <b-datepicker
          class="analytics-date-picker"
          v-model="to_date"
          position="is-bottom-left"
          required
          icon="calendar-today"
          trap-focus
          v-on:input="getByDate"
        >
        </b-datepicker>
      </div>
      <div class="level-right is-6 is-button-group">
        <div class="dropdown-country-list">
          <b-dropdown
            v-model="selectedOptions"
            multiple
            ref="dropdownCountry"
            aria-role="list"
            @change="checkCountry($event)"
          >
            <button class="button is-primary" type="button" slot="trigger">
              <span>Countries ({{ selectedOptions.length }})</span>
              <b-icon icon="menu-down"></b-icon>
            </button>

            <b-dropdown-item
              custom
              aria-role="listitem"
              v-for="(country, index) in dropdownCountries"
              :value="country"
              :key="index"
            >
              <b-checkbox
                @input="$refs.dropdownCountry.selectItem(country)"
                value="true"
              >
                <span>{{ country }}</span>
              </b-checkbox>
            </b-dropdown-item>
          </b-dropdown>
          <b-loading
            :is-full-page="isFullPage"
            v-model="isLoading"
            :can-cancel="true"
          >
            <b-icon icon="loading" size="is-large"> </b-icon>
          </b-loading>
        </div>
        <div class="dropdown-stream-list">
          <b-dropdown
            v-model="selectedStreams"
            multiple
            ref="dropdownStream"
            aria-role="list"
            @change="checkStream($event)"
          >
            <button class="button is-primary" type="button" slot="trigger">
              <span>Streams ({{ selectedStreams.length }})</span>
              <b-icon icon="menu-down"></b-icon>
            </button>

            <b-dropdown-item
              custom
              aria-role="listitem"
              v-for="(stream, index) in dropdownStreams"
              :value="stream"
              :key="index"
            >
              <b-checkbox
                @input="$refs.dropdownStream.selectItem(stream)"
                value="true"
              >
                <span>{{ stream }}</span>
              </b-checkbox>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <apexchart
      v-if="series.length > 0 && chartOptions"
      class="daysBeforeDeadLine"
      type="line"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import analyticsService from "@/services/AnalyticsService";
import utitlityMixin from "@/mixins/UtilityMixin";
// @group Analytics
export default {
  name: "AnalyticsView",
  mixins: [utitlityMixin],
  data() {
    return {
      from_date: this.sixMonthsBefore(),
      to_date: this.currentDate(),
      year: this.currentYear(),
      isLoading: true,
      isFullPage: true,
      switchCustomerId: null,
      reportIDs: [],
      selectedOptions: [],
      selectedStreams: [],
      dropdownCountries: [],
      dropdownStreams: [],
      analyticsService: new analyticsService(),
      series: [
        {
          name: "Data Delivery Deadline",
          data: [6, 6, 6, 6, 6, 6, 6, 6],
          date: [2, 4, 2, 2, 2, 4, 2, 9],
          actual_diff: [2, 4, 2, 2, 2, 4, 2, 9]
        }
      ],
      chartOptions: {}
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    this.fetchReportsDaysBeforeDeadline(true);
  },
  methods: {
    breakIntoParts(arr) {
      arr.forEach((element, index) => {
        if (element !== null) {
          let middle = Math.floor(element.length / 2);
          const before = element.lastIndexOf("-", middle);
          const after = element.indexOf("-", middle + 1);

          if (middle - before < after - middle) {
            middle = before;
          } else {
            middle = after;
          }
          arr[index] = [
            String(element).substr(0, middle),
            String(element).substr(middle + 1)
          ];
        } else {
          arr[index] = ["-1"];
        }
      });
      return arr;
    },
    checkCountry(event) {
      this.selectedOptions = event;
      this.isLoading = true;
      if (this.selectedOptions.length == 0) {
        this.selectedOptions = -1;
      }
      this.fetchReportsDaysBeforeDeadline(false);
    },
    checkStream(event) {
      this.selectedStreams = event;
      this.isLoading = true;
      if (this.selectedStreams.length == 0) {
        this.selectedStreams = -1;
      }
      this.fetchReportsDaysBeforeDeadline(false);
    },
    getByDate() {
      this.fetchReportsDaysBeforeDeadline(false);
    },
    fetchReportsDaysBeforeDeadline(mounted) {
      const start_date = this.dateFormatterNew(this.from_date);
      const end_date = this.dateFormatterNew(this.to_date);

      if (start_date != null && end_date != null && start_date >= end_date) {
        alert("end date should be greater than start date");
        return false;
      }
      this.analyticsService
        .getReportDaysBeforeDeadline(
          this.switchCustomerId,
          start_date,
          end_date,
          this.selectedOptions,
          this.selectedStreams
        )
        .subscribe(
          response => {
            this.dropdownCountries = response["all_countries"];
            this.dropdownStreams = response["all_streams"];
            if (mounted == true) {
              this.selectedOptions = response["all_countries"];
              this.selectedStreams = response["all_streams"];
            }
            this.reportIDs = response.report_ids;
            this.series[0].data = response.days;
            this.series[0].date = response.final_dataset_delivering_deadline;
            this.series[0].actual_diff = response.actual_difference;
            const labels = this.breakIntoParts(response.report_id);
            this.chartOptions = {
              chart: {
                height: 450,
                type: "line",
                dropShadow: {
                  enabled: true,
                  color: "#000",
                  top: 18,
                  left: 7,
                  blur: 10,
                  opacity: 0.2
                },
                toolbar: {
                  show: true
                },
                zoom: {
                  enabled: false
                }
              },
              colors: ["#2BABE2"],
              markers: {
                size: 4
              },
              dataLabels: {
                enabled: true,
                position: "top",
                offsetY: -7
              },
              stroke: {
                curve: "straight"
              },
              xaxis: {
                categories: labels,
                labels: {
                  rotate: -80,
                  rotateAlways: true,
                  offsetX: -5,
                  hideOverlappingLabels: true,
                  style: {
                    cssClass: labels.length > 15 ? "hide-labels" : ""
                  }
                },
                tooltip: {
                  enabled: true
                }
              },
              grid: {
                padding: {
                  left: 15
                }
              },
              legend: {
                show: false
              },
              annotations: {
                yaxis: [
                  {
                    y: response.data_delivery_deadline[0],
                    borderColor: "#FF8000",
                    strokeDashArray: 0,
                    fillColor: "#FF8000",
                    opacity: 0.8,
                    offsetX: 0,
                    width: "100%"
                  },
                  {
                    y: 0,
                    borderColor: "#EA4335",
                    strokeDashArray: 0,
                    fillColor: "#EA4335",
                    opacity: 0.8,
                    offsetX: 0,
                    width: "100%"
                  }
                ]
              },
              tooltip: {
                y: {
                  formatter: function(
                    value,
                    { series, seriesIndex, dataPointIndex, w }
                  ) {
                    const adjustedValue = value;
                    if (adjustedValue === 0) {
                      return " on Scheme Deadline";
                    } else if (adjustedValue > 0) {
                      return adjustedValue === 1
                        ? Math.abs(adjustedValue) +
                            " day before Scheme Deadline"
                        : Math.abs(adjustedValue) +
                            " days before Scheme Deadline";
                    } else {
                      return adjustedValue === -1
                        ? Math.abs(adjustedValue) + " day after Scheme Deadline"
                        : Math.abs(adjustedValue) +
                            " days after Scheme Deadline";
                    }
                  },
                  title: {
                    formatter: seriesName => {
                      return "Data Delivered";
                    }
                  }
                }
              },
              noData: {
                text: "Sorry, No Data for the selected",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0
              }
            };
            //this.chartOptions.categories = ["df","ds","dsds"];
            this.isLoading = false;
          },
          error => {
            console.log("error loading data");
          }
        );
    }
  }
};
</script>
